import styled, { keyframes } from "styled-components";

const shimmer = keyframes`
  0% { background-position: -400px 0; }
  100% { background-position: 400px 0; }
`;

export const Skeleton = styled.div<{
  $w?: string;
  $h?: string;
  $radius?: string;
  $mb?: string;
}>`
  width: ${({ $w }) => $w || "100%"};
  height: ${({ $h }) => $h || "16px"};
  border-radius: ${({ $radius }) => $radius || "6px"};
  margin-bottom: ${({ $mb }) => $mb || "0"};
  background: #ece6df;
  background-image: linear-gradient(
    90deg,
    #ece6df 0px,
    #f5f1ec 200px,
    #ece6df 400px
  );
  background-size: 800px 100%;
  animation: ${shimmer} 1.2s ease-in-out infinite;
`;

export default Skeleton;
